import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-toggle"
//
// Toggles password field visibility with an eye icon button
//
// Usage:
//   .input-group data-controller="password-toggle"
//     input.form-control type="password" data-password-toggle-target="input"
//     button.btn.btn-outline-secondary type="button" data-action="click->password-toggle#toggle"
//       i.fa.fa-eye data-password-toggle-target="icon"
//
export default class extends Controller {
  static targets = ["input", "icon"]

  toggle() {
    const input = this.inputTarget
    const icon = this.iconTarget

    if (input.type === "password") {
      // Show password
      input.type = "text"
      icon.classList.remove("fa-eye")
      icon.classList.add("fa-eye-slash")
    } else {
      // Hide password
      input.type = "password"
      icon.classList.remove("fa-eye-slash")
      icon.classList.add("fa-eye")
    }
  }
}
